// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiEndPoint: "https://lb4bapi.liveb4buy.com/lb4b/api/v1",
  // partnerEndPoint : "https://partner.liveb4buy.com/lb4b/partner/v1",
  apiEndPoint: "https://lb4bapi-dev.liveb4buy.com/lb4b/api/v1",
  partnerEndPoint : "https://partner-dev.liveb4buy.com/lb4b/partner/v1",
  imgmetaEndPoint : "https://imgmetadata.liveb4buy.com/lb4b/image_metadata/v1",
  billingEndPoint : "https://billing.liveb4buy.com/lb4b/billing/v1"
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
